import { Outlet } from 'react-router';

import { useMemo } from 'react';

import { styled } from '@mui/material';

import { ReactQueryLoader, Box, Logo, BoxContainer } from '@app-velocity/ui';

import { useI18n } from '@app-velocity/i18n';

import { UsersQueryKey } from '../../queries/UsersQueryKey';
import { useRouterContext } from '../../router/useRouterContext';

const StyledLogoContainer = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(16),
  flex: 1,
  display: 'flex',
  alignItems: 'flex-start'
}));

const StyledSpacer = styled('div')(({ theme }) => ({
  // padding: `${theme.spacing(16)} 0`,
  flex: 1,
  display: 'flex',
  alignItems: 'center'
}));

const StyledMainContent = styled('div')({
  flex: '0 1 auto',
  width: '100%',
  display: 'flex',
  justifyContent: 'center'
})

const StyledBottomSpacer = styled('div')(({ theme }) => ({
  flex: 1,
  display: 'flex',
  alignItems: 'flex-end',
  padding: 8
}));

export const AuthLayout = () => {
  const { t } = useI18n();
  const { strategy } = useRouterContext();

  const messages = useMemo(() => {
    return {
      [t('users:auth.authenticating')]: UsersQueryKey.Login,
      [t('users:reset_password.resetting')]: UsersQueryKey.ResetPassword,
      [t('users:update_password.updating')]: UsersQueryKey.UpdatePassword,
      [t('users:auth.registering')]: UsersQueryKey.Register,
    };
  }, [t]);

  return (
    <Box
      data-testid="auth-layout"
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: strategy === 'WEB_APP' ? 'space-between' : 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      {strategy === 'WEB_APP' ? (
        <StyledLogoContainer>
          <Logo />
        </StyledLogoContainer>
      ) : <StyledSpacer />}
      <StyledMainContent>
        <BoxContainer>
          <ReactQueryLoader fallbackKeys={messages}>
            <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', gap: 4 }}>
              <Outlet />
            </Box>
          </ReactQueryLoader>
        </BoxContainer>
      </StyledMainContent>
      <StyledBottomSpacer />
    </Box>
  );
};
